export default __webpack_public_path__ + "static/media/selector.39a64fa0.svg";